import App from './App.vue'
import Vue from 'vue'
import config from './config/app'
import store from './store/index'
import router from './router/index'
import VueKonva from 'vue-konva'
import './plugins/userAgentChecker'
import './assets/scss/app.scss'
import './plugins/money'

import {
  MessageBox,
} from 'element-ui'
import 'element-ui/lib/theme-chalk/message-box.css'

window.axios = require('axios')

Vue.use(config)
Vue.use(VueKonva)

Vue.prototype.$msgbox = MessageBox
Vue.prototype.$confirm = MessageBox.confirm

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
